import * as React from 'react';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { IDNameViewModel } from 'TypeGen/id-name-view-model';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { useIsMobile } from 'utils/useIsMobile';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';

type DropdownFilterCellProps = {
  value: number;
  data: IDNameViewModel[];
} & Omit<GridCustomFilterCellProps, 'value'>;

export const DropdownFilterCellIDName = (props: DropdownFilterCellProps) => {
    const isMobile = useIsMobile();
    const checkValue = (value: number) => value > 0;
    const onChange = (event: DropDownListChangeEvent) => {
        const hasValue = checkValue(event.target.value.ID);
        props.onChange({
            value: hasValue ? event.target.value.ID : '',
            operator: hasValue ? 'eq' : '',
            syntheticEvent: event.syntheticEvent
        });
    }

    const onClearButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        props.onChange({
            value: '',
            operator: '',
            syntheticEvent: event
        });
    }
    return (
      <HeaderTdElement {...props.thProps}>
        <span className="k-filtercell">
          <DropDownList
            data={props.data}
            onChange={onChange}
            value={props.data.find(x => x.ID === props.value)}
            textField="Name"
            dataItemKey="ID"
            defaultItem={{ID: 0, Name: 'Select'}}
          />
          {!isMobile && <Button
            title="Clear"
            disabled={!checkValue(props.value)}
            onClick={onClearButtonClick}
            icon="filter-clear"
            svgIcon={filterClearIcon}
          />}
        </span>
      </HeaderTdElement>
    );
}